import { useAutoneTranslation } from '@autone/translations';
import {
  TailwindButton,
  TailwindPopover,
  type TailwindPopoverContentProps,
  TailwindPopoverTrigger,
} from '@autone/ui';
import { ListFilter } from 'lucide-react';

import { type APP_NAME } from '../../consts';
import {
  useAssortmentAdvancedFilters,
  useAssortmentGeneralFilters,
} from '../../hooks';

import { FiltersPopoverContent } from './filters-popover-content';
import { type TableNamesWithAnyFilters } from './types';

interface AssortmentFilterButtonProps extends TailwindPopoverContentProps {
  tableName: TableNamesWithAnyFilters;
}

const AssortmentFilterButton = ({
  tableName,
  ...popoverContentProps
}: AssortmentFilterButtonProps) => {
  const { common } = useAutoneTranslation<typeof APP_NAME>();

  const { selectedGeneralFiltersCount, dynamicFiltersQueryResult } =
    useAssortmentGeneralFilters(tableName);
  const { selectedAdvancedFiltersCount } =
    useAssortmentAdvancedFilters(tableName);

  const { isLoading } = dynamicFiltersQueryResult ?? {};

  const selectedOptionsCount =
    selectedGeneralFiltersCount + selectedAdvancedFiltersCount;

  return (
    <TailwindPopover>
      <TailwindPopoverTrigger asChild>
        <TailwindButton
          disabled={isLoading || !dynamicFiltersQueryResult}
          className="flex flex-row gap-2 h-12"
          color={selectedOptionsCount ? 'primary' : 'secondary'}
          variant={'outlined'}
          size="lg"
        >
          <ListFilter size={16} />
          {common('filters.header')}
          {selectedOptionsCount ? ` (${selectedOptionsCount})` : ''}
        </TailwindButton>
      </TailwindPopoverTrigger>
      <FiltersPopoverContent {...popoverContentProps} tableName={tableName} />
    </TailwindPopover>
  );
};

export default AssortmentFilterButton;
